export default "__VITE_ASSET__073039e1__"